import { useEffect, useState } from "react"
import { Formik } from "formik"
import AxiosInstance from "../utils/AxiosInstance"
import { useNavigate } from "react-router-dom"
import { setProfile } from "../stores/appSlice"
import { useAppDispatch } from "../stores/hooks"
import { store } from "../stores"
import { useAlert } from "react-alert"

const Signin = () => {
  const navigate = useNavigate()
  const dispatchApp = useAppDispatch()
  const token = localStorage.getItem("token")
  const [loginSuccess, setLoginSuccess] = useState(token ? true : false)
  const alert = useAlert()

  useEffect(() => {
    if (loginSuccess) {
      navigate("/")
    }
  }, [loginSuccess])

  const onsubmit = async (values: any) => {
    const data = {
      email: values.email,
      password: values.password,
      isAdmin: true
    }
    const res: any = await AxiosInstance.post("auth/signin", data)
      if (res?.data?.statusCode === 200) {
      if (res?.data?.data?.user?.role_name === "Admin") {
        
        localStorage.setItem("token", res?.data?.data?.access_token);
        setTimeout(() => {
          dispatchApp(setProfile(res?.data?.data?.user))
          setLoginSuccess(true)
        }, 500)
        
        // navigate("/verify-otp", { state: { email: values.email } })
        window.location.reload()
      } 
      else {
        alert(
          "You are not an administrator, Please try with another credentials."
        )
        navigate("/signin")
      }
    } else if (res?.statusCode === 404) {
      alert.error("Please enter valid details.")
    }
    else if(res?.statusCode === 400){
      alert.error(res?.message);
    }
  }

  return (
    <div className="auth-wrapper">
      <div className="auth-content">
        <div className="auth-bg">
          <span className="r"></span>
          <span className="r s"></span>
          <span className="r s"></span>
          <span className="r"></span>
        </div>

        <Formik
          initialValues={{
            email: "",
            password: "",
          }}
          enableReinitialize={true}
          validate={(values) => {
            const errors: any = {}

            if (!values.email) {
              errors.email = "Required"
            } else if (
              !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
            ) {
              errors.email = "Please enter valid email."
            }

            if (!values.password) {
              errors.password = "Required"
            }
            return errors
          }}
          onSubmit={onsubmit}
        >
          {({
            values,
            errors,
            touched,
            handleChange,
            handleBlur,
            handleSubmit,
            isSubmitting,
            /* and other goodies */
          }) => (
            <form onSubmit={handleSubmit}>
              <div className="card">
                <div className="card-body text-center">
                  <div className="mb-4">
                    {/* <img className="login-logo" src="" /> */}
                    <i className="feather icon-unlock auth-icon"></i>
                  </div>
                  <h3 className="mb-4">Login</h3>
                  <div className="input-group mb-3">
                    <input
                      className="form-control"
                      type="email"
                      name="email"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.email}
                      placeholder="Email"
                      autoFocus={true}
                    />
                    <div className="e-message">
                      {errors.email && touched.email && errors.email}
                    </div>
                  </div>

                  <div className="input-group mb-4">
                    <input
                      className={
                        errors.password && touched.password && errors.password
                          ? "form-control error"
                          : "form-control"
                      }
                      type="password"
                      name="password"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      value={values.password}
                      placeholder="Password"
                    />
                    <div className="e-message">
                      {errors.password && touched.password && errors.password}
                    </div>
                  </div>
                  <button
                    type="submit"
                    className="btn btn-primary shadow-2 mb-4 mt-4"
                  >
                    Login
                  </button>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </div>
  )
}

export default Signin
